import {
  GET_HOT_OFFERS_SUCCESS,
  GET_HOT_OFFER_SUCCESS,
  GET_OFFERS_SUCCESS,
  GET_OFFER_SUCCESS,
} from './types';

const initialState = {
  offers: null,
  offer: [],
  hotOffers: [],
  hotOffer: {},
};

export const offersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFERS_SUCCESS:
      return {
        ...state,
        offers: action.payload,
      };
    case GET_OFFER_SUCCESS:
      return {
        ...state,
        offer: action.payload,
      };
    case GET_HOT_OFFERS_SUCCESS:
      return {
        ...state,
        hotOffers: action.payload,
      };
    case GET_HOT_OFFER_SUCCESS:
      return {
        ...state,
        hotOffer: action.payload,
      };
    default:
      return state;
  }
};
